var map = {
	"./label.svg": 883,
	"./left.svg": 44,
	"./money.svg": 452,
	"./right.svg": 79,
	"./statistics.svg": 354,
	"assets/icons/label.svg": 883,
	"assets/icons/left.svg": 44,
	"assets/icons/money.svg": 452,
	"assets/icons/right.svg": 79,
	"assets/icons/statistics.svg": 354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 566;